/**
 * Hand-offs from the library's selection: the Literature matrix with only these papers, or the
 * assistant ready to compare them. Not kept across reloads.
 */
import { create } from "zustand";
import { openView, useUi } from "@/lib/store";
import { track } from "@/lib/analytics";

export interface CompareHandoff {
  workspaceId: string;
  ids: string[];
  nonce: number;
}

export const useCompare = create<{ matrix: CompareHandoff | null; assistant: CompareHandoff | null }>(() => ({ matrix: null, assistant: null }));

export function compareInMatrix(workspaceId: string, ids: string[]) {
  useCompare.setState({ matrix: { workspaceId, ids, nonce: Date.now() } });
  track("feature", { feature: "compare_matrix" });
  openView("matrix", workspaceId, "Literature matrix");
}

export function compareWithAi(workspaceId: string, ids: string[]) {
  useCompare.setState({ assistant: { workspaceId, ids, nonce: Date.now() } });
  useUi.getState().setRightPanel("assistant");
}
